import {Request} from "../../../request.abstract";
import {Settings} from "../../../settings.model";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {SettingInterface} from "./api.models";

export class SettingsEndpoint extends Request {
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    collection(): Observable<SettingInterface[]> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/settings');
    }

    resource(setting: string): Observable<SettingInterface> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/settings/' + setting);
    }

    set(name:string, value: any): Observable<SettingInterface> {
        return this.put('/v1/bases/' + this.baseId + '/proxy/v1/settings/' + name, {value: value});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/settings/api.service.ts